/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {MpProductModalComponent} from './mp-product-modal.component';

export interface MpProductModalOptions {
  allProducts: any[];
  initialAxProduct?: any;
  isMarketplace?: boolean;
  initialActiveTab?: 'table' | 'block';
  onSave?: (axProduct: any, allAxProducts: any[]) => Promise<any>;
  onSaved?: () => void;
}

@Injectable({providedIn: 'root'})
export class MpProductModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: MpProductModalOptions): void {
    this.angularModalService.show(MpProductModalComponent, {
      class: 'modal-lg',
      initialState: options
    });
  }
}
